import api from "./api";


export const updateDetailUser = async (id, userData) => {
  const { data } = await api.put(`/usuarios/${id}`, userData);
  return data;
};

export const getUsuarios = async (
  page,
  size,
  texto,
  
) => {
  const response = await api.get("/usuarios", {
    params: {
      page,
      size,
      texto,
      
    }
  });

  return response.data;
};

// User por id
export const getUserById = async (id) => {
  const { data } = await api.get(`/usuarios/${id}`);
  return data;
};

// Crear usuario
export const createUser = async (userData) => {
  const { data } = await api.post("/usuarios/create", userData);
  return data;
};

// Obtener todas las actas
export const getAllActas = async (
  page = 0,
  size = 10,
  folio = null,
  estadoId = null,
  

) => {

  try {
    const params = {
      page,
      size,
      folio,
      estadoId
      
    };

    if (folio) {
      params.folio = folio;
    }

    if (estadoId) {
      params.estadoId = estadoId;
    }
    

    const response = await api.get(`/actas`, {
      params,

    });
    return response.data;
  } catch (error) {
    if (error.response?.status === 401) {
      localStorage.removeItem('jwt');
      window.location.reload();
    }
    throw error;
  }
};

export const getAllActasProceso = async (
  page = 0,
  size = 10,
  folio = null,
  estadoId = null,
  

) => {

  try {
    const params = {
      page,
      size,
      folio,
      estadoId
      
    };

    if (folio) {
      params.folio = folio;
    }

    if (estadoId) {
      params.estadoId = estadoId;
    }
    

    const response = await api.get(`/actas/en-proceso`, {
      params,

    });
    return response.data;
  } catch (error) {
    if (error.response?.status === 401) {
      localStorage.removeItem('jwt');
      window.location.reload();
    }
    throw error;
  }
};

export const getAllActasDTR = async (
  page = 0,
  size = 10,
  folio = null,
  estadoId = null,
  

) => {

  try {
    const params = {
      page,
      size,
      folio,
      estadoId
      
    };

    if (folio) {
      params.folio = folio;
    }

    if (estadoId) {
      params.estadoId = estadoId;
    }
    

    const response = await api.get(`/actas/en-dtr`, {
      params,

    });
    return response.data;
  } catch (error) {
    if (error.response?.status === 401) {
      localStorage.removeItem('jwt');
      window.location.reload();
    }
    throw error;
  }
};

export const getAllActasSUS = async (
  page = 0,
  size = 10,
  folio = null,
  estadoId = null,
  

) => {

  try {
    const params = {
      page,
      size,
      folio,
      estadoId
      
    };

    if (folio) {
      params.folio = folio;
    }

    if (estadoId) {
      params.estadoId = estadoId;
    }
    

    const response = await api.get(`/actas/en-sus`, {
      params,

    });
    return response.data;
  } catch (error) {
    if (error.response?.status === 401) {
      localStorage.removeItem('jwt');
      window.location.reload();
    }
    throw error;
  }
};

export const verArchivo = async (nombreArchivo) => {
  try {

    

    const response = await api.get(
      `auth/files/${nombreArchivo}`,
      {
        responseType: "blob",
        
      }
    );

    const fileURL = URL.createObjectURL(response.data);

    window.open(fileURL, "_blank");

  } catch (error) {
    console.error(error);
  }
};

// Activar usuario
export const activateUser = async (id) => {
  const { data } = await api.patch(`usuarios/${id}/cstatus`);
  return data;
};